import { render, staticRenderFns } from "./SideBarLeft.vue?vue&type=template&id=ff9e6b7c&scoped=true"
import script from "./SideBarLeft.vue?vue&type=script&lang=js"
export * from "./SideBarLeft.vue?vue&type=script&lang=js"
import style0 from "./SideBarLeft.vue?vue&type=style&index=0&id=ff9e6b7c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff9e6b7c",
  null
  
)

export default component.exports